import i18n from "i18n";

// Le etichette sono lette al momento dell'uso (getter), cosi' seguono la lingua corrente.
const opt = (value, key) => ({
  value,
  get label() {
    return i18n.t(key);
  },
});

export const roleOptions = [
  opt("admin", "common:roles.admin"),
  opt("user", "common:roles.user"),
  opt("reseller", "common:roles.reseller"),
];

export const sortOptions = [
  opt("", "common:options.all"),
  opt("oldest", "common:options.oldest"),
  opt("latest", "common:options.latest"),
];

export const filterOptions = [
  opt("", "common:options.all"),
  opt("oldest", "common:options.oldest"),
  opt("latest", "common:options.latest"),
  opt("assign", "common:options.assigned"),
  opt("unassign", "common:options.unassigned"),
];

export const roleOptionsFilter = [
  opt("", "common:options.all"),
  opt("admin", "common:roles.admin"),
  opt("user", "common:roles.user"),
  opt("reseller", "common:roles.reseller"),
];
